import { render, staticRenderFns } from "./ServerDown.vue?vue&type=template&id=ab0212be&scoped=true&"
import script from "./ServerDown.vue?vue&type=script&lang=js&"
export * from "./ServerDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0212be",
  null
  
)

export default component.exports